import Highcharts from 'highcharts';
Highcharts.setOptions({
	lang: {
		      decimalPoint: ','
	      }

});

export const figure44 = {
  chart: {
      zoomType: 'xy',
      animation: false,
      marginTop: 50,
      marginLeft: 180,
      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false,
      type: 'bar',
      height: '600px',
      backgroundColor: 'rgba(255, 255, 255, 0.0)',
      style: {
        fontFamily: 'Montserrat'
      }
    },

    colors: ['#00b0f0', '#b4c7e7'],

    credits: {
      enabled: false
    },
    title: {
      text: null
    },
    subtitle: {
      text: null
    },

    plotOptions: {
      series: {
        borderWidth: 0,
        marker: {
          symbol: 'circle',
          enabled: false,
          states: {
            hover: {
              enabled: true,
              radius: 5
            }
          }
        }
      }
    },

    exporting: {
      enabled: false
    },

    xAxis: [{
		 categories: [
	      "Menos de 11 USD/m³",
	      "11 a 20 USD/m³",
	      "21 a 30 USD/m³",
	      "31 a 40 USD/m³",
	      "41 a 50 USD/m³",
	      "51 a 60 USD/m³",
	      "61 a 70 USD/m³",
	      "71 a 80 USD/m³",
	      "81 a 90 USD/m³",
	      "91 a 100 USD/m³",
	      "Más de 100 USD/m³",
      ],
      lineColor: "#d7d7d7",
      tickColor: "#d7d7d7",
      tickLength: 16,
      title: {
	     useHTML: true,	
	     text: 'USD/m<sup>3</sup>',
	     offset: 110,
        style: {
          fontWeight: 'normal',
          color: '#999999',
          fontSize: '12px'
	      }
      },
    }],
    yAxis: [{
      labels: {
        format: '{value}',
        style: {
          fontWeight: 'normal',
          color: '#999999',
          fontSize: '12px'
        },
      },
      max: 50,
      min: 0,
      tickInterval: 10,
      gridLineWidth: 0,
      title: {
        text: 'Porcentaje (%)',
        style: {
          color: Highcharts.getOptions().colors[1]
        }
      }
    }],
    tooltip: {
      shared: true,
      useHTML: true,
      hideDelay: 500,
      backgroundColor: null,
      borderWidth: 0,
      shadow: false,
      style: {
        padding: 0
      }
    },
    legend: {
      enabled: false,
    },

    series: [
    {
	    name: '2015',
	    tooltip: {
			  valueSuffix: '%'
		  },
		  dataLabels: {
			  enabled: false,
			  style: {
					   fontWeight: 'normal',
					   textOutline: false,
					   color: '#999999',
					   fontSize: '12px'
				   }
		  },
		  data: [
			 42,
			 16,
			 6,
			 7,
			 6,
			 4,
			 2,
			 2,
			 2,
			 2,
			 11,
			],
    },
    {
    name: '2020',
      tooltip: {
        valueSuffix: '%'
      },
      dataLabels: {
        enabled: false,
        style: {
          fontWeight: 'normal',
          textOutline: false,
          color: '#999999',
          fontSize: '12px'
        }
      },
      data: [
        41,
        16,
        7,
        7,
        4,
        5,
        1,
        3,
	3,
	3,
        9,
      ]
    }]
}
